/**
 * MediaPreview.jsx
 * Renders an image or a video, whichever the media record is.
 *
 * Video posters are not generated anywhere, so a muted inline video with
 * metadata preloaded stands in for a thumbnail — it shows the first frame and
 * plays on click.
 */

import { api } from '../services/api.js';

export default function MediaPreview({ media, className = '', controls = false, onClick }) {
  const src = api.media.rawUrl(media.id);

  if (media.kind === 'video') {
    return (
      <video
        className={className}
        src={src}
        muted
        playsInline
        preload="metadata"
        controls={controls}
        onClick={onClick}
      />
    );
  }

  return <img className={className} src={src} alt={media.alt_text || ''} onClick={onClick} />;
}

/** "0:42" — for captions under thumbnails. */
export function formatDuration(seconds) {
  if (!seconds) return '';
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
